import * as React from "react";
import * as ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";

import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap-theme.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap-select/dist/css/bootstrap-select.css";
import "bootstrap-select/dist/js/bootstrap-select.js";
import "bootstrap-tagsinput/dist/bootstrap-tagsinput-typeahead.css";
import "bootstrap-tagsinput/dist/bootstrap-tagsinput.css";
import "corejs-typeahead/dist/typeahead.bundle.js";
import "react-notifications/lib/notifications.css";
import "x-editable/dist/bootstrap3-editable/css/bootstrap-editable.css";
import "x-editable/dist/bootstrap3-editable/js/bootstrap-editable.js";

import App from "./App";

import "./main.css";

ReactDOM.render(
    <Router>
        <App />
    </Router>,
    document.getElementById("root")
);
